import { ListManagerFrontendError } from './ListManagerFrontendError';

// Superclass for errors involving React reducers.
export class ReducerError extends ListManagerFrontendError {
  static errorName = 'ReducerError';
}
